import { render, staticRenderFns } from "./SVGPrint.vue?vue&type=template&id=645c7f86&scoped=true&"
import script from "./SVGPrint.vue?vue&type=script&lang=js&"
export * from "./SVGPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645c7f86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645c7f86')) {
      api.createRecord('645c7f86', component.options)
    } else {
      api.reload('645c7f86', component.options)
    }
    module.hot.accept("./SVGPrint.vue?vue&type=template&id=645c7f86&scoped=true&", function () {
      api.rerender('645c7f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGPrint.vue"
export default component.exports